<template>
  <div>
    <div :class="$style.subscriptions">
      <Subscription
        v-for="sub in subscriptions"
        :key="sub.productCode"
        :currentPlan="plan"
        :handleNextStep="handleNextStep"
        :isAnnual="isAnnual"
        :isPricingPage="isPricingPage"
        :item="sub"
        @viewFeatureMatrix="handleViewFeatureMatrix"
      />
    </div>
    <LoadingOverlay
      :showLoadingOverlay="loading"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import LoadingOverlay from 'client/components/LoadingOverlay/LoadingOverlay.vue';
import PaymentStepMixin from 'client/Payments/mixins/PaymentStepMixin';
import Subscription from 'client/Payments/pricingMatrix/Subscription';
import SubscriptionConstants from 'client/Payments/pricingMatrix/SubscriptionConstants';

const planModule = 'PlanModule';
const subscriptionCollection = 'SubscriptionCollection';
const { ProductCodeToSubscriptionType } = SubscriptionConstants;

export default {
  name: 'PricingMatrix',

  components: {
    LoadingOverlay,
    Subscription,
  },

  mixins: [PaymentStepMixin],

  props: {
    isAnnual: Boolean,
    isPricingPage: Boolean,
  },

  data() {
    return {
      loading: false,
      ProductCodeToSubscriptionType,
    };
  },

  computed: {
    ...mapGetters(subscriptionCollection, {
      activeSubscriptions: 'getCollection',
    }),

    ...mapGetters(planModule, [
      'hasAnnualContractType',
    ]),

    ...mapState(planModule, [
      'plan',
    ]),

    subscriptions() {
      if (this.loading) return [];

      const subscriptions = [
        ...this.activeSubscriptions,
      ];

      return subscriptions;
    },
  },

  async mounted() {
    if (!this.activeSubscriptions.length) {
      this.loading = true;
      await this.fetchCollection()
        .finally(() => {
          this.loading = false;
        });
    }
  },

  methods: {
    ...mapActions(planModule, ['fetchPlan']),
    ...mapActions(subscriptionCollection, ['fetchCollection']),

    handleViewFeatureMatrix() {
      this.$emit('viewFeatureMatrix');
    },
  },
};
</script>

<style scope module>
.subscriptions {
  display: flex;
  justify-content: space-evenly;
  margin-top: 2rem;
}

</style>
